// make a commonent to call api for get slides and set it to slidesBanner component to show slided
// React
import React, { useEffect, useState, useContext } from "react";
// React
// CSS
import styles from "./TicketSlidesBanner.module.css";
// CSS
// Models
import { I_TicketingSlides } from "../../../../Models/interfaces";
// Models
import "react-loading-skeleton/dist/skeleton.css";
import SlidesBanner from "../../../../Components/SlidesBanner/SlidesBanner";
import { toast } from "react-toastify";
import { getTicketingSlidersService } from "../../../../Services/Tickets/get/getTicketingSlidersService";
import { UserTokenContext } from "../../../../Contexts/userToken";
// Skeleton

const TicketSlidesBanner: React.FC = () => {
  const userToken = useContext(UserTokenContext);
  const [slides, setSlides] = useState<I_TicketingSlides[]>([]);
  const [isPending, setIsPending] = useState<boolean>(true);

  useEffect(() => {
    if (userToken === "init" || "") return;

    getTicketingSlidersService(userToken)
      .then(({ data }) => {
        setSlides(data);
        setIsPending(false);
      })
      .catch((err) => {
        console.log(err);
        setIsPending(false);
        toast(
          err.response.data.message ? err.response.data.message : err.message,
        );
      });
  }, [userToken]);

  return (
    <div
      className={`${styles.ticketSlidesBannerContainer} flex items-center justify-center relative pb-0`}
    >
      <SlidesBanner
        slides={
          (slides &&
            slides.length &&
            slides.map((item) => ({
              ...item,
              url: item.image ? item.image.url : "",
            }))) ||
          []
        }
        isPending={isPending}
      />
    </div>
  );
};

export default TicketSlidesBanner;
